import React, { useState } from 'react';
import { Label } from '@fluentui/react';
import { CustomDatePicker, CustomTimePicker } from '../atoms';

import styles from './DateTimeField.module.scss';

export interface IDateTimeField {
	label: string;
	description: string;
	required: boolean;
	defaultValue?: Date;
	error?: string;
	onChange: (datetime: Date) => void;
}

export const DateTimeField = (props: IDateTimeField) => {
	const [currentDateTime, setCurrentDateTime] = useState<Date | undefined>(props.defaultValue);

	const changeDate = (date: Date) => {
		const newDate = new Date(date);
		newDate.setHours(currentDateTime?.getHours() ?? 0);
		newDate.setMinutes(currentDateTime?.getMinutes() ?? 0);

		setCurrentDateTime(newDate);
		props.onChange(newDate);
	};

	const onChangeTime = (time: { h: number; m: number }) => {
		if (!currentDateTime) return;

		const newDate = new Date(currentDateTime);
		newDate.setHours(time.h);
		newDate.setMinutes(time.m);
		setCurrentDateTime(newDate);

		props.onChange(newDate);
	};

	return (
		<div>
			<Label required={props.required}>{props.label}</Label>
			<div className={styles.content}>
				<div className={styles.datetime}>
					<CustomDatePicker selectedDate={currentDateTime} onChange={changeDate} />
					<CustomTimePicker
						value={{ h: currentDateTime?.getHours() ?? 0, m: currentDateTime?.getMinutes() ?? 0 }}
						onChange={onChangeTime}
					/>
				</div>
				{props.error !== '' ? <div className={styles.errorText}>{props.error}</div> : <></>}
				<p className={styles.descriptionText}>{props.description}</p>
			</div>
		</div>
	);
};
